module.exports = __webpack_public_path__ + "img/首页轮播图4.1cbc7fd7.png";